import { schemaTranslations as e } from "./translations.js";
import { createLocalization as t } from "@scalar/localization";
//#region src/schema/localization/index.ts
var { useLocalization: n } = t({
	localeTranslations: e,
	defaultLocale: "en",
	rtlLocales: /* @__PURE__ */ new Set([
		"ar",
		"fa",
		"he",
		"ur"
	]),
	logPrefix: "[@scalar/blocks/schema]"
});
//#endregion
export { n as useLocalization };

//# sourceMappingURL=index.js.map